<template lang="pug">
.settings-team
	page-header
		h1.highlight Your Team
	page
		partial-two-col
			template(slot="left")
				h2 Invite teammate
				p Add members of your team by inviting them to create an account. Different roles have different permissions.&nbsp;
					br
					br
					a(href="#", @click="permissionsModal()") Show role permissions.
			template(slot="right")
				invite-user
		partial-two-col
			template(slot="left")
				h2 Manage teammates
				p All your team members will show in this list. Select one or more to delete them.
				el-button(type="danger", v-if="multipleSelection.length", @click="deleteUsers") Delete {{ multipleSelection.length }} {{ multipleSelection.length > 1 ? "teammates" : "teammate" }}
			template(slot="right")
				user-list(ref="userList", @update-selection="updateSelection")
</template>

<script>
import ConfirmDeletion from "@/components/modals/ConfirmDeletion";
import InviteUser from "./includes/InviteUser";
import UserList from "./includes/UserList";
import gql from "graphql-tag";

export default {
	components: {
		InviteUser,
		UserList
	},

	data() {
		return {
			multipleSelection: []
		};
	},

	methods: {
		permissionsModal() {
			this.$vuedals.open({
				component: () => import("@/components/modals/PermissionsModal.vue"),
				title: "User Permissions"
			});
		},
		updateSelection(data) {
			this.multipleSelection = data;
		},
		async deleteUsers() {
			const selectedIds = this.multipleSelection.map(s => s.id);

			this.$vuedals.open({
				component: ConfirmDeletion,
				title: "Please confirm to remove teammates",
				props: {
					value: "confirm"
				},
				onClose: async confirm => {
					if (!confirm) return;

					try {
						await this.$apollo.mutate({
							mutation: gql`
								mutation DeleteUserCompanies($input: DeleteUserCompaniesInput!) {
									DeleteUserCompanies(input: $input)
								}
							`,
							variables: {
								input: { ids: selectedIds }
							},
							update: store => {
								const updateUserCacheQuery = gql`
									query Users($page: Int) {
										Users(cursor: $page) {
											results {
												id
												company_id
											}
											cursor
										}
									}
								`;

								const cachedData = store.readQuery({ query: updateUserCacheQuery, variables: { page: 1 } });
								cachedData.Users.results = cachedData.Users.results.filter(result => !selectedIds.includes(`${result.id}:${result.company_id}`));

								store.writeQuery({
									query: updateUserCacheQuery,
									variables: {
										page: 1
									},
									cachedData
								});
							}
						});

						this.$message.success("Deleted");
					} catch (error) {
						if (error.graphQLErrors.find(e => e.message == "Permission denied - Delete self")) {
							this.$message.error("You can't delete yourself");
							return;
						}

						this.$message.error("Oops, something went wrong! Please contact support");
					}
				}
			});
		}
	}
};
</script>
